// extracted by mini-css-extract-plugin
export var DialogOverlay = "CaptureModal-module--DialogOverlay--HraMZ";
export var DialogContent = "CaptureModal-module--DialogContent--8BXjg";
export var formGroup = "CaptureModal-module--formGroup--2Pc3G";
export var submitButton = "CaptureModal-module--submitButton--2onE8";
export var email = "CaptureModal-module--email--3AvXL";